define('lq/events/eventActionFactory',[
    'lq/typesProvider',

    './actions/activeDirectorySyncGroupUsers',
    './actions/azureAIBatchCommand',
    './actions/azureAICommand',
    './actions/azureAIDocumentFillerCommand',
    './actions/backgroundTask',
    './actions/breakEvent',
    './actions/calendarURLExport',
    './actions/changeParameter',
    './actions/changePassword',
    './actions/checkIn',
    './actions/checkOut',
    './actions/copyDynamicContentCommand',
    './actions/copyToClipboard',
    './actions/cq',
    './actions/create',
    './actions/createTextFileCommand',
    './actions/exportCommand',
    './actions/deleteCommand',
    './actions/deleteDynamicContentCommand',
    './actions/distanceMatrix',
    './actions/desktopClientCommand',
    './actions/documentZip',
    './actions/domainFunctionCommand',
    './actions/download',
    './actions/downloadFileCommand',
    './actions/executeEidReader',
    './actions/executeEidSigner',
    './actions/executeMethod',
    './actions/executePlugin',
    './actions/executeQuery',
    './actions/executeTimer',
    './actions/extractMailAttachment',
    './actions/eYouthAuthenticationCommand',
    './actions/eYouthAuthenticationLogoutCommand',
    './actions/federatedLogin',
    './actions/thirdPartyAccessRequestCommand',
    './actions/focus',
    './actions/forEach',
    './actions/formula',
    './actions/generateText',
    './actions/import',
    './actions/languageCommand',
    './actions/login',
    './actions/confirmEmailMfaCommand',
    './actions/logoffCommand',
    './actions/mail',
    './actions/mapping',
    './actions/mollie',
    './actions/mollieCreateCustomer',
    './actions/mollieUpdateCustomer',
    './actions/officeAddinLoginCommand',
    './actions/openDocumentInOfficeOnline',
    './actions/payment',
    './actions/paypal',
    './actions/pdfDataCommand',
    './actions/pdfMergeCommand',
    './actions/pdfMergeCommand_v2',
    './actions/platformCommand',
    './actions/plugInLogin',
    './actions/pushNotificationsCommand',
    './actions/raiseEvent',
    './actions/readOutlookMessage',
    './actions/redirect',
    './actions/refreshCaptcha',
    './actions/refreshLoggedInUserCommand',
    './actions/reportCommand',
    './actions/rssCommand',
    './actions/saveMorph',
    './actions/scheduledTaskCommand',
    './actions/scrollTo',
    './actions/serverCommand',
    './actions/setParameterFromEvent',
    './actions/setVisibility',
    './actions/shareOnFacebook',
    './actions/shareOnLinkedIn',
    './actions/shareOnTwitter',
    './actions/sms',
    './actions/startImpersonatingCommand',
    './actions/stopImpersonatingCommand',
    './actions/thirdPartyLogin',
    './actions/transformRichText',
    './actions/undoCheckOut',
    './actions/update',
    './actions/urlGenerator',
    './actions/windowsLoginCommand',
    './actions/popupGoogleLogin',
    './actions/bigBlueButtonJoinMeetingCommand',
    './actions/bigBlueButtonStartMeetingCommand',
    './actions/googleGeocodingQuery',
    './actions/downloadExternalDocumentCommand',
    './actions/rawSqlCommand',
    './actions/asyncSender',
    './actions/asyncEventTrigger',
    './actions/asyncEventReceiver',
    './actions/share',
    './actions/labelImageCommand',
    './actions/webserviceClient',
    './actions/businessLogicBlockCommand',
    './actions/addToHomeScreenCommand',
    './actions/translationCommand',
    './actions/asyncDeletion',
    './actions/enablePushNotificationsCommand',
    './actions/cqCommand',
    './actions/cqExecutionCommand',
    './actions/validateCommand',
    './actions/apiCallv2',
    './actions/processEngineScheduler'
], function (TypesProvider) {
    'use strict';

    var eventActionTypes = Array.prototype.slice.call(arguments, 1);
    var typesProvider = new TypesProvider(eventActionTypes);

    var currentEventActionId = 0;

    var EventActionFactory = function (rootDrop) {
        this.rootDrop = rootDrop;
    };

    EventActionFactory.prototype.createEventActions = function (event, eventSource, eventArg, abortion) {
        var self = this;
        return _.map(event.actions, function (data) {
            var EventActionType = typesProvider.get(data.eventActionType);
            var eventAction = new EventActionType(data, eventArg);
            eventAction.eventSource = eventSource;
            eventAction.rootDrop = self.rootDrop;
            eventAction.piping = self.rootDrop.piping;
            eventAction.eventActionId = ++currentEventActionId;
            eventAction.eventActionTypeName = data.eventActionType;
            eventAction.abortion = abortion;
            return eventAction;
        });
    };

    return EventActionFactory;
});
